export default {
      id: "logo-usage",
      viewBox: "0 0 400 400",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#logo",
      toString: function () {
        return this.url;
      }
    }